export const NEXT_TEMPLATE_RULES = [
  { id: 'amount', label: 'По сумме покупок' },
  { id: 'purchases', label: 'По количеству покупок' },
];

export function wouldCreateCycle(templates, fromId, toId) {
  if (!toId) return false;
  if (String(fromId) === String(toId)) return true;

  const byId = new Map(templates.map((t) => [String(t._id), t]));
  let current = String(toId);
  const visited = new Set([String(fromId)]);

  while (current) {
    if (visited.has(current)) return true;
    visited.add(current);
    const node = byId.get(current);
    current = node?.nextTemplateId ? String(node.nextTemplateId) : null;
  }

  return false;
}

export function getAllowedNextTargets(templates, fromId) {
  return templates.filter(
    (t) => String(t._id) !== String(fromId) && !wouldCreateCycle(templates, fromId, t._id),
  );
}

export function getTransitionHint(template, templates) {
  if (!template?.nextTemplateId) return null;
  const next = templates.find((t) => String(t._id) === String(template.nextTemplateId));
  if (!next) return null;

  const rule = template.nextTemplateRule || 'amount';
  const nextName = next.name || 'следующий уровень';

  if (rule === 'purchases') {
    const count = template.nextTemplatePurchaseCount ?? 0;
    if (count <= 0) return null;
    return { nextName, label: `${count} покупок` };
  }

  const amount = template.nextTemplateAmount ?? 0;
  if (amount <= 0) return null;
  return {
    nextName,
    label: `${Number(amount).toLocaleString('ru-RU')} ₽`,
  };
}
